import type { BillingPrice } from "@/utils/billing";

export type PaidPlanChangeText =
  | "Upgrade"
  | "Downgrade"
  | "Switch"
  | "Subscribe";

/** Yearly catalog amounts are the billed annual total; monthly amounts are per month. */
const monthlyAmount = (
  price: Pick<BillingPrice, "amount" | "interval">
): number => (price.interval === "year" ? price.amount / 12 : price.amount);

/**
 * Label for moving between paid prices. Same product + different interval is
 * always "Switch". Otherwise compare monthly equivalents so a yearly total
 * is not treated as more expensive than a monthly price of a higher plan.
 */
export const paidPlanChangeText = (
  current: Pick<BillingPrice, "amount" | "interval">,
  target: Pick<BillingPrice, "amount" | "interval">,
  options: { sameProduct: boolean; canceled: boolean }
): PaidPlanChangeText => {
  if (options.sameProduct) return "Switch";
  if (monthlyAmount(current) < monthlyAmount(target)) {
    return "Upgrade";
  }
  return options.canceled ? "Subscribe" : "Downgrade";
};
